import { services } from '@ambita/ambita-components-core';
import * as statesConstants from '../constants/componentStates';

const classUtils = services.domUtils.classUtils;

const tagStatesMixin = {
  init() {
    this.states = {
      INITIAL: statesConstants.INITIAL,
      LOADING: statesConstants.LOADING,
      DONE_SUCCESS: statesConstants.DONE_SUCCESS,
      DONE_FAILED: statesConstants.DONE_FAILED
    };
  },

  updateState(newState) {
    this.state = newState;
    this.update();
  },

  /**
   * Set a state(class) on the attached tag
   * @param {string} state - the state(class) to set
   */
  setState(state: string) {
    const tagLocalName = this.root.localName;
    const tagState = `${tagLocalName}--${state}`;

    if (!classUtils.hasClass(this.root, tagState)) {
      classUtils.addClass(this.root, tagState);
      this.update();
    }
  },

  /**
   * Remove a state(class) from the attached tag
   * @param {string} state - the state(class) to remove
   */
  removeState(state: string) {
    const tagLocalName = this.root.localName;
    const tagState = `${tagLocalName}--${state}`;

    if (classUtils.hasClass(this.root, tagState)) {
      classUtils.removeClass(this.root, tagState);
      this.update();
    }
  }
};

export = tagStatesMixin;
